/** 48 -> "4 Years", 27 -> "2 yrs 3 mos", 5 -> "5 mos", null -> "–". */
export function formatAge(months: number | null | undefined): string {
  if (months == null || !Number.isFinite(months) || months < 0) return '–';
  const m = Math.round(months);
  const y = Math.floor(m / 12);
  const r = m % 12;
  if (y === 0) return `${r} ${r === 1 ? 'mo' : 'mos'}`;
  if (r === 0) return `${y} ${y === 1 ? 'Year' : 'Years'}`;
  return `${y} yrs ${r} mos`;
}
